exports.cs = {
  CSPS_DISBURSEMENT: {
    DPS: {
      TITLE: 'Doplňkové penzijní spoření',
      TOTAL_SAVED_AMOUNT: 'Naspořeno:',
      PARTY_CONTRIBUTION_SUM: 'z toho příspěvky účastníka:',
      EMPLOYER_CONTRIBUTION_SUM: 'z toho příspěvky zaměstnavatele:',
      STATE_CONTRIBUTION_SUM: 'z toho státní příspěvky:',
      YIELD_SUM: 'z toho zhodnocení:',
      PENSION_TYPE: {
        LABEL: 'Typ penze na dobu určenou:',
        FIXED_TERM: 'S definovanou dobou',
        FIXED_RENT: 'V definované výši'
      },
      DESIRED_DISBURSEMENT_PERIOD: 'Požadovaná doba výplaty:',
      DESIRED_PENSION_AMOUNT: 'Požadovaná výplata:',
      DESIRED_PENSION_AMOUNT_ERROR: 'Požadovaná výplata je vzhledem k naspořené částce příliš vysoká.',
      DISBURSEMENT_COMBINATION: {
        LABEL: 'Kombinace dávek (penze / jednorázové vyrovnání):',
        YES: 'Ano',
        NO: 'Ne'
      },
      DISBURSEMENT_RATIO: 'Požadovaný poměr penze:',
      RESULT: {
        PENSION_AMOUNT_BEFORE_TAX: 'Hrubá výše výměru penze na dobu určenou:',
        PENSION_TAX: 'Daň:',
        RENT_DISBURSEMENT_PERIOD: 'Doba výplaty:',
        PENSION_AMOUNT_AFTER_TAX: 'Čistá výše výměru penze na dobu určenou:',
        DISBURSEMENT_AMOUNT_BEFORE_TAX: 'Hrubá výše výměru jednorázového vyrovnání:',
        DISBURSEMENT_TAX: 'Daň:',
        DISBURSEMENT_AMOUNT_AFTER_TAX: 'Čistá výše výměru jednorázového vyrovnání:',
        RATIO: '(%{ratio} % peněžních prostředků)'
      }
    },
    PP: {
      TITLE: 'Penzijní připojištění',
      BIRTH_DATE: 'Datum narození:',
      GENDER: 'Pohlaví:',
      GENDER_FEMALE: 'Žena',
      GENDER_MALE: 'Muž',
      CALCULATION_AGE: 'Věk při výměru penze:',
      TOTAL_SAVED_AMOUNT: 'Naspořeno:',
      PARTY_CONTRIBUTION_SUM: 'z toho příspěvky účastníka:',
      EMPLOYER_CONTRIBUTION_SUM: 'z toho příspěvky zaměstnavatele:',
      STATE_CONTRIBUTION_SUM: 'z toho státní příspěvky:',
      YIELD_SUM: 'z toho zhodnocení:',
      HINT: {
        LABEL: 'TIP',
        TEXT: 'Pro výplatu penze je potřeba splnit minimální věk 60 let a dobu spoření na penzijní připojištění minimálně 60 měsíců'
      },
      RESULT: {
        PENSION_AMOUNT: 'Výše výměru doživotní penze bez sjednané pozůstalostní penze:',
        DISBURSEMENT_AMOUNT_BEFORE_TAX: 'Hrubá výše výměru jednorázového vyrovnání:',
        TAX: 'Výše odvedené daně:',
        RETIREMENT_DATE: 'Datum přiznání penze:',
        DISBURSEMENT_AMOUNT_AFTER_TAX: 'Výše výplaty jednorázového vyrovnání:',
        PENSION_AMOUNT_GROSS: 'Hrubá výše výměru penze:',
        PENSION_AMOUNT_NETT: 'Výše výplaty penze:'
      }
    },
    CZK: 'Kč',
    MONTHS: 'měsíc |||| měsíce |||| měsíců',
    YEARS: 'rok |||| roky |||| let'
  }
}
